import { SourcePaymentList } from './SourcePaymentList'
import { SourcePaymentCreate } from './SourcePaymentCreate'
import { SourcePaymentEdit } from './SourcePaymentEdit'
import { SourcePaymentShow } from './SourcePaymentShow'


export { SourcePaymentList, SourcePaymentCreate, SourcePaymentEdit, SourcePaymentShow}